<template>
  <div class="page preview js_show" v-if="this.search.salesmanId!=''&&this.search.salesmanId!=null">
    <div class="page__hd" style="text-align: center;">
      <h1 class="page__title">{{search.salesmanName}},建设的</h1>
      <p class="page__desc">门店列表信息</p>
    </div>

    <div class=" page__ft" style="margin-top: 10px;margin-bottom: 10px">
      <a class="weui-btn weui-btn_primary " href="javascript:" id="showTooltips" @click="handleCreate">我要建新</a>
    </div>

    <div class="page__bd">
      <div class="weui-form-preview" v-for="(item, i) in shopInfoList">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label colo" v-if="item.workFlag == '3' &&  item.buildStep == 5">
              <i class="weui-icon-success weui-icon_msg1 "></i>已完成
            </label>
            <label class="weui-form-preview__label colo" v-if="item.workFlag == '1'">
              <i class="weui-icon-waiting weui-icon_msg1 "></i>待补全
            </label>
            <label class="weui-form-preview__label colo" v-if="item.workFlag == '2' ">
              <i class="weui-icon-warn weui-icon_msg1 "></i>审核不通过
            </label>
            <label class="weui-form-preview__label colo" v-if="item.workFlag == '3' &&  item.buildStep != 5">
              <i class="weui-icon-success weui-icon_msg1 "></i>已过审
            </label>
            <em class="weui-form-preview__value">{{item.shopName}}</em>
          </div>
        </div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">法人名称</label>
            <span class="weui-form-preview__value">{{item.shopExecutor}}</span>
          </div>
          <!--<div class="weui-form-preview__item">
            <label class="weui-form-preview__label">联系电话</label>
            <span class="weui-form-preview__value">{{item.shopPhone}}</span>
          </div>-->
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">营执地址</label>
            <span class="weui-form-preview__value">{{item.shopAddress}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">创建时间</label>
            <span class="weui-form-preview__value"> {{$moment(item.gmtCreate).format('YYYY-MM-DD HH:mm:ss')}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="item.wcheckResult != null">
            <label class="weui-form-preview__label">审核结果</label>
            <span class="weui-form-preview__value">{{item.wcheckResult.remark}}</span>
          </div>
        </div>
        <div class="weui-form-preview__ft">
          <a class="weui-form-preview__btn weui-form-preview__btn_primary"
             href="javascript:"
             @click="shopDetail(item.id)" >详情</a>
        </div>
      </div>
    </div>

    <div v-if="shopInfoList.length == 0"
         class="weui-form-preview">
      <div class="weui-form-preview__hd">
        <div class="weui-form-preview__item">
          <em class="weui-form-preview__value"
              style="text-align: center;color: #8c939d">无数据,等待新建中..</em>
        </div>
      </div>
    </div>

  </div>

  <div class="page preview js_show"
       v-else-if="this.search.salesmanId == '' || this.search.salesmanId == null">
    <div class="page__hd" style="text-align: center;">
      <h1 class="page__title">您还没注册|登录</h1>
      <p class="page__desc" style="margin-left: 20px;margin-right: 20px">业务员注册登录,根据您的手机号自行注册，如果之前已注册则进行自动登录原账号；通过佰药汇运营人员审核后,才可以进行门店新建。</p>
    </div><br>
    <div class="page__ft" style="margin-top: 10px;margin-bottom: 10px;">
      <a class="weui-btn weui-btn_primary"
         href="javascript:"
         id="showTooltips1"
         @click="registerWorker">我要注册业务员</a>
    </div>
  </div>
</template>

<script>
export default {
  /* eslint-disable */
  data () {
    return {
      search: {
        deptList: '',
        salesmanId: '',
        salesmanPhone: '',
        salesmanName: ''
      },
      shopInfoList: []
    }
  },
  methods: {
    buildStepFormat(row, column) {
      return row.buildStep == 1 ? '30%' : row.buildStep == 2 ? "80%" : "100%";
    },
    shopDetail (id) {
      this.$router.push({path: 'jdcenter/' + id})
    },
    handleSearch () {
      console.log('hi')
    },
    handleCreate(){
      this.$router.push({path: 'jdcenter/0'})
    },
    initShopInfoList () {
      this.$axios({
        method: 'get',
        url: 'v1/wShopRegister/getShopInfoList?salesmanId=' + this.search.salesmanId
      }).then((response) => {
        console.log(response)
        this.shopInfoList = response.data.data
        console.log(this.shopInfoList)
      })
    },
    registerWorker() {
      this.$router.push({path: 'jdworkerRegister'})
    }
  },
  mounted() {
    let user = this.$storage.fetchStorage("user")
    if (user != null) {
      this.search.salesmanPhone = user.userPhone
      this.search.salesmanName = user.username
      this.search.salesmanId = user.id
      this.initShopInfoList()
    } else {
      //this.$router.push({path: 'workerRegister'})
    }

  },
  components: {

  }
}
</script>

<style>
  .none{display: none}
  .toolbar {

    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    max-width: 100%;
    left: 0;
    right: 0;
    bottom: 0px; /*置底*/
    margin: auto;
  }
</style>



// WEBPACK FOOTER //
// src/views/jdDeptManage/jddeptMan.vue